import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
export class EditLeverantorsorderCommand extends BasicCommand<EditLeverantorsorderCommand> {
    primaryKey: import("~app/common/services/cqs/IPrimaryKey").IPrimaryKey<EditLeverantorsorderCommand>;
    leverantorsorderId: number;
    avtalansvarigId: number;
    kontakt: string;
    status: string;

    constructor(leverantorsorderId: number) {
        super("EditLeverantorsorderCommand", "leverantorsorder", CommandType.Replace);
        this.leverantorsorderId = leverantorsorderId;
    }
}
